// extracted by mini-css-extract-plugin
module.exports = {"issueItem":"IssueItem_issueItem__ph2HV","image":"IssueItem_image__Xqkma","overlay":"IssueItem_overlay__EysDT"};